/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unlinkAccountAdmin} from '../api'

export const useMutationUnlinkAccountAdmin = createReactQueryMutationHook('unlinkAccountAdmin', unlinkAccountAdmin)
